import React from "react";
import PropTypes from "prop-types";
import { Navigate } from "react-router-dom";
import useAuth from "hooks/useAuth";

const BankSettingGuard = ({ children }) => {
  const { user, isLoggedIn } = useAuth();

  if (isLoggedIn && user && user.canViewBankSetting === false) {
    return <Navigate to="/dashboard/default" replace />;
  }

  return children;
};

BankSettingGuard.propTypes = {
  children: PropTypes.node,
};

export default BankSettingGuard;
